import React, { useState, useEffect } from "react";
import slugify from "slugify";
import { If } from "react-condition";
import { useParams } from "react-router-dom";
import axios from "../../../services/axios";
import TextField from "../ApplicationView/TextField";
import Checkbox from "../ApplicationView/Checkbox";
import TextArea from "../ApplicationView/TextArea";
import EmailField from "../ApplicationView/EmailField";
import PasswordField from "../ApplicationView/PasswordField";
import NumberField from "../ApplicationView/NumberField";
import DateField from "../ApplicationView/DateField";
import Paragraph from "../ApplicationView/Paragraph";
import MultiSelect from "./MultiSelect";
import FileInput from "./FileInput";
import ProfessionalExperience from "./ProfessionalExperience";
import Select from "./Select";
import RadioChild from "../RadioChild";
import DateTime from "./DateTime";

function Radio({
  onBlurHandler,
  isInputFieldTouched,
  data,
  defaultValue,
  isChild,
  approve,
  editable,
  ocrDisabled,
  errorInputs,
  tokenType,
}) {
  const { id, ids } = useParams();
  const formId = id;
  const candidateId = ids;
  const [hasChiledReadOnly, setHasChildReadOnly] = useState(false);
  const [defValue, setDefValue] = useState("");
  const [element, setElement] = useState({
    type: "radio",
    properties: {
      label: "Radio question field.",
      options: [],
      columns: 1,
    },
    required: false,
  });

  const [readOnly, setReadOnly] = useState(false);
  //set child to required by default -Lovejot(08-DEC-2022)
  useEffect(() => {
    setStatus(data.properties.value);
    setElement((prev) => ({ ...prev, ...data }));
    // if (isChild) {
    //   let obj = { ...data };
    //   obj.properties.required = true;
    //   setElement((prev) => ({ ...prev, ...obj }));
    // }

    //check prefilled field -Lovejot(07-DEC-2022)
    if (
      data?.properties.disableField === true &&
      data?.properties?.value &&
      data?.properties?.value?.length !== 0 &&
      localStorage.getItem("user.role") !== "admin"
    ) {
      setReadOnly(true);
    } else {
      setReadOnly(false);
    }
  }, [data, data.properties.value, isChild]);

  const [status, setStatus] = useState("");

  const handleRadio = (e) => {
    setStatus(e.target.value);
  };

  const foundError = errorInputs?.find(
    (ele) => ele?.label === element?.properties?.label
  );

  return (
    <div className="form-group mb-3 col-md-12 form-builder-element">
      <label htmlFor="">
        {element.properties.label}
        <If test={element?.properties?.required === true}>
          <span style={{ color: "red" }}>*</span>
        </If>
      </label>

      <div className="row">
        {element.properties.options.map((v, k) => (
          <div key={k} className={"col-md-" + 12 / element.properties.columns}>
            <div className="custom-control custom-radio mb-3">
              <input
                onBlur={onBlurHandler}
                disabled={
                  readOnly ||
                  approve ||
                  !element.editable ||
                  (defValue && hasChiledReadOnly) ||
                  editable ||
                  ocrDisabled
                }
                name={slugify(element.properties.label)}
                id={slugify(element.properties.label) + k}
                type="radio"
                className={`custom-control-input form-view`}
                label={element.properties.label}
                data={JSON.stringify(element)}
                value={v}
                onChange={(e) => {
                  handleRadio(e);
                  if (isInputFieldTouched) {
                    isInputFieldTouched();
                  }
                }}
                checked={v === status}
                defaultValue={element.properties.value}
              />
              <label
                htmlFor={slugify(element.properties.label) + k}
                className={
                  "custom-control-label" + (foundError ? " error_radio" : "")
                }
              >
                {v}
              </label>
            </div>
          </div>
        ))}
        {foundError && (
          <span className="text-danger pl-3">{foundError?.value}</span>
        )}
      </div>
      {data?.parent &&
        data?.parent.map((ele) => {
          if (ele.child) {
            ele.child.editable = true;
          }
          if (ele?.pValue === status) {
            switch (ele?.child?.type) {
              case "radio":
                return (
                  <RadioChild
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    approve={approve}
                    errorInputs={errorInputs}
                    editable={!element.editable}
                    hasChiledReadOnly={hasChiledReadOnly}
                    tokenType={tokenType}
                  />
                );
              case "select":
                return (
                  <Select
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "text":
                return (
                  <TextField
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "email":
                return (
                  <EmailField
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "checkbox":
                return (
                  <Checkbox
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    approve={approve}
                    errorInputs={errorInputs}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "number":
                return (
                  <NumberField
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "textarea":
                return (
                  <TextArea
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "date":
                return (
                  <DateField
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "password":
                return (
                  <PasswordField
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "paragraph":
                return (
                  <Paragraph
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "multiSelect":
                return (
                  <MultiSelect
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "datetime":
                return (
                  <DateTime
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "file":
                return (
                  <FileInput
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "professionalexperience":
                return (
                  <ProfessionalExperience
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    approve={approve}
                    errorInputs={errorInputs}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              default:
                return null;
            }
          }
          return null;
        })}
    </div>
  );
}

export default Radio;
